import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { Anchor, Box, Center, Container, Flex, Group, Stack } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import Logo from '@/components/Logo';
import { ROUTES } from '@/routes/paths';

// Сплит-экран: слева форма (с явным выходом «← На сайт» и кликабельным лого), справа — узкая
// фирменная фото-полоса (ширина как у левого фото hero, 28%). Изображение sticky и высотой в
// один вьюпорт — одинаковый кадр на всех экранах независимо от высоты формы. На мобильном скрыто.
export default function AuthLayout() {
  const { t } = useTranslation();

  return (
    <Flex align="stretch" style={{ minHeight: '100dvh' }}>
      <Flex direction="column" flex="1" p="md" mih="100dvh">
        <Anchor
          component={Link}
          to={ROUTES.HOME}
          c="brand.7"
          fz="md"
          fw={600}
          underline="never"
          w="fit-content"
        >
          <Group gap={6} wrap="nowrap">
            <IconArrowLeft size={20} />
            {t('auth.backToSite')}
          </Group>
        </Anchor>

        <Center flex={1} py="lg">
          <Container size={550} w="100%" p={0}>
            <Stack gap="lg">
              <Group justify="center">
                <Logo height={32} />
              </Group>
              <Outlet />
            </Stack>
          </Container>
        </Center>
      </Flex>

      <Box visibleFrom="md" w="28%" style={{ position: 'relative' }}>
        <Box
          style={{
            position: 'sticky',
            top: 0,
            height: '100dvh',
            backgroundImage: 'url(/images/login-pic.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </Box>
    </Flex>
  );
}
